export default __webpack_public_path__ + "static/media/kroket.ef3e5c32.jpeg";